// icons/ClockCircleIcon.jsx

const ClockCircleIcon = ({
  size = 72,
  bgColor = "#FFF5E8",
  stroke = "#FF9800"
}) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "9999px",
        background: bgColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <svg
        width={size * 0.5}
        height={size * 0.5}
        viewBox="0 0 24 24"
        fill="none"
      >
        {/* circle */}
        <circle
          cx="12"
          cy="12"
          r="8"
          stroke={stroke}
          strokeWidth="2"
        />

        {/* hands */}
        <path
          d="M12 8V12L15 14"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default ClockCircleIcon;